import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var SpinnerMobileButton =
/** @class */
function (_super) {
  __extends(SpinnerMobileButton, _super);

  function SpinnerMobileButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SpinnerMobileButton.prototype.onClick = function () {
    this.$emit('click');
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], SpinnerMobileButton.prototype, "requesting", void 0);

  __decorate([Prop({
    type: String
  })], SpinnerMobileButton.prototype, "title", void 0);

  SpinnerMobileButton = __decorate([Component({
    name: 'SpinnerMobileButton'
  })], SpinnerMobileButton);
  return SpinnerMobileButton;
}(Vue);

export default SpinnerMobileButton;